module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-vi-mentors.json
// module id = 676
// module chunks = 76677121700818